/**
 * Domain normalization and validation utilities.
 * Shared between CanaryStep (create) and ReviewSummary (edit).
 */

export const FQDN_REGEX = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i

export function normalizeDomain(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\/.*$/, '')
}

export function validateDomain(value: string): string | null {
  if (!value) return 'Please enter the website address.'
  if (!FQDN_REGEX.test(value)) return 'Please enter a valid domain (e.g., example.com).'
  return null
}
